var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ButtonBack',{staticClass:"mb_m"}),_c('input-name'),_c('input-description'),_c('input-url'),_c('input-location'),_c('input-radius'),_c('search-location',{staticClass:"mt_m"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }